module.exports = require("shortid");


//////////////////
// WEBPACK FOOTER
// external "shortid"
// module id = 5
// module chunks = 0